
export const loginWithOkta = async (oktaAuth) => {
  try {
    // This will redirect user to Okta login page
    await oktaAuth.signInWithRedirect({ 
  originalUri: '/',   
  prompt: 'login'  // forces login page
})
  } catch (err) {
    console.error('Okta login error:', err);
    throw err;
  }
};
